module.exports = __webpack_public_path__ + "favorite-star-full.svg?534ac90fbdf4afe3b552131191f089b5";